export default __webpack_public_path__ + "static/media/clairefontaine2.168d8066.jpg";